import {createContext} from 'react'
import {createContextualCan} from '@casl/react'
import {Ability, AbilityClass} from '@casl/ability'

export type Actions = 'manage' | 'create' | 'read' | 'update' | 'delete' | 'approve'
export type Subjects = string | 'all'

export type AppAbility = Ability<[Actions, Subjects]>
export const AppAbility = Ability as AbilityClass<AppAbility>

export const defaultAbility = new AppAbility([])
export const AbilityContext = createContext<AppAbility>(defaultAbility)
export const Can = createContextualCan(AbilityContext.Consumer)
